import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import DropdownLayout from '../../DropdownLayout';
import Text from '../../Text';
import styles from './styles.st.css';

var DropdownPicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownPicker, _React$Component);

  var _super = _createSuper(DropdownPicker);

  function DropdownPicker(props) {
    var _this;

    _classCallCheck(this, DropdownPicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      _this.setState({
        isOpen: false
      });

      _this.stopAllEventsThatCanOpenModalInSameEventLoop = true;
      setTimeout(function () {
        // for next event loop we allow them
        _this.stopAllEventsThatCanOpenModalInSameEventLoop = false;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (data) {
      _this.props.onChange(data);

      _this.onClose();
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDropdown", function () {
      if (!_this.stopAllEventsThatCanOpenModalInSameEventLoop) {
        _this.setState({
          isOpen: !_this.state.isOpen
        });
      }
    });

    _this.stopAllEventsThatCanOpenModalInSameEventLoop = false;
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(DropdownPicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          caption = _this$props.caption,
          options = _this$props.options,
          dataHook = _this$props.dataHook,
          selectedId = _this$props.selectedId;
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: styles.root
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.button,
        onClick: this.toggleDropdown
      }, /*#__PURE__*/React.createElement(Text, {
        dataHook: "".concat(dataHook, "-button")
      }, caption), /*#__PURE__*/React.createElement("div", {
        className: styles.icon
      }, /*#__PURE__*/React.createElement(ChevronDown, null))), isOpen && /*#__PURE__*/React.createElement("div", {
        className: styles.dropdown
      }, /*#__PURE__*/React.createElement(DropdownLayout, {
        dataHook: "".concat(dataHook, "-menu"),
        focusOnSelectedOption: true,
        visible: isOpen,
        options: options,
        onSelect: this.onSelect,
        onClickOutside: this.onClose,
        closeOnSelect: true,
        selectedId: selectedId
      })));
    }
  }]);

  return DropdownPicker;
}(React.Component);

_defineProperty(DropdownPicker, "propTypes", {
  dataHook: PropTypes.string,
  caption: PropTypes.node,
  options: PropTypes.array,
  onChange: PropTypes.func,
  selectedId: PropTypes.number
});

export { DropdownPicker as default };